<template>
  <div class="pages member">
    <hsj-pro-member v-if="app === 'hsjpro'"/>
    <hsj-member v-else/>
  </div>
</template>

<script>
import { testApp } from '@/utils';
import HsjMember from './hsj/Member';
import HsjProMember from './hsjpro/Member';
export default {
  name: "Member",
  components: {HsjMember, HsjProMember},
  data() {
    return {
      app: null
    }
  },
  computed: {},
  created() {
    const app = this.$route.params?.app;
    this.app = app;
    if (app === "hsjpro") {
      document.title = "画世界Pro会员协议";
    }
  },
  methods: {
    testApp,
    isHsjPro() {
      return this.testApp('hsjpro');
    }
  }
};
</script>

<style lang="scss">
</style>
